<template>
  <div class="subscribe1">
    <div class="log-btn">
      <el-button type="primary" @click="refreshData">
        刷新
      </el-button>
    </div>
    <list-block>
      <div class="table-sty">
        <el-table
          height="407px"
          :data="list"
          border
          style="width: 100%"
          :loading="loading"
        >
          <el-table-column
            prop="taskName"
            label="任务名称"
          />
          <el-table-column
            prop="createTime"
            label="创建时间"
          >
            <template slot-scope="scope">
              {{ handleTime(scope.row.createTime) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createUserName"
            label="创建人"
          />
          <el-table-column
            prop="info"
            label="任务结果"
            width="300"
          >
            <template slot-scope="scope">
              {{ scope.row.info?`总共：${scope.row.info.total}, 失败${scope.row.info.errorCount},${scope.row.info.errorMessage}`:'' }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="80"
          >
            <template slot-scope="scope">
              <a v-if="scope.row.targetFileUrl" :href="scope.row.targetFileUrl">下载</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        ref="shipperPagination"
        :total="total"
        :page-sizes="[10, 20, 50, 100]"
        @search="fetchData"
      />
    </list-block>
  </div>
</template>
<script>
import ListBlock from '@/components/ListBlock/index.vue';
import { fetchImportLogList } from '@/api/userControl';
import pagination from '@/components/Pagination/index.vue';
import dayjs from 'dayjs';

export default {
  name: 'CatImportLog',
  components: {
    ListBlock,
    pagination,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    current: {
      type: Object,
      default: null,
    },

  },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      page: 1,
      size: 10,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    refreshData() {
      this.page = 1;
      this.$refs.shipperPagination.resetPage();
      this.fetchData();
    },
    handleTime(val) {
      return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
    },
    async fetchData(page, size) {
      this.loading = true;
      this.page = page || this.page;
      this.size = size || this.size;
      try {
        const data = {
          businessType: 'CONTROL_EQU_FILE_UPLOAD',
        };
        const params = {
          page: this.page,
          size: this.size,
          sort: 'createTime__DESC',
        };
        const resp = await fetchImportLogList(data, params);
        this.total = resp.total;
        this.list = resp.records;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .log-btn{
    overflow: hidden;
    margin-top: -10px;
    margin-bottom: -20px;
    margin-right: 25px;
    .el-button{
      float: right;
    }
  }
</style>
